export const QuotationTypes = [ 'domestic', 'international' ] as const;
export type QuotationType = typeof QuotationTypes[number];